<template>
  <q-dialog v-model="add">
    <q-card style="width: 320px">
      <q-form @submit="onSubmit" ref="myForm" class="flexbox">
        <div class="q-pa-md">
          <div class="row q-col-gutter-xs">
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <q-select
                outlined
                color="grey-7"
                label-color="grey-7"
                label="Type"
                :options="types"
                :option-label="(type) => type.name"
                :option-value="(type) => type.value"
                :rules="[typeChecker]"
                v-model="type"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <q-select
                label="Select Class Names"
                v-model="class_name"
                outlined
                multiple
                :option-label="(class_name) => class_name.name"
                label-color="grey-7"
                color="grey-7"
                lazy-rules
                :rules="[classChecker]"
                :options="class_names"
              >
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
              <q-select
                label="Select Location"
                v-model="location_id"
                outlined
                :display-value="shorter"
                multiple
                :disable="locations.length === 0 || loading"
                label-color="grey-7"
                color="grey-7"
                :rules="[locationChecker]"
                hide-bottom-space
                :options="locations"
              >
                <template v-slot:append>
                  <q-icon
                    size="15px"
                    style="margin-top: 3px"
                    v-if="!!location_id.length > 0"
                    class="cursor-pointer"
                    name="fas fa-times"
                    @click="location_id = []"
                    @click.stop="!location_id.length === 0"
                  />
                </template>
                <template v-slot:option="locations">
                  <q-item
                    @click="locationFilterPusher(locations.opt)"
                    dense
                    clickable
                    v-ripple
                  >
                    <q-item-section side top>
                      <q-checkbox
                        size="xs"
                        v-model="location_id"
                        :val="locations.opt"
                      />
                    </q-item-section>
                    <q-item-section>{{ locations.opt.code }}</q-item-section>
                  </q-item>
                </template>
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-italic text-grey">
                      There is no options.
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </div>
            <div class="col-md-6 col-xs-6 col-lg-12 col-xl-12">
              <q-input
                label="End Date Of Report"
                style="margin-top: 15px"
                outlined
                v-model="addDate"
                mask="##/##/####"
                lazy-rules
                :rules="[checkDate]"
              >
                <template v-slot:append>
                  <q-icon name="far fa-calendar-plus" class="cursor-pointer">
                    <q-popup-proxy
                      ref="qDateProxy"
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        @input="() => $refs.qDateProxy.hide()"
                        mask="MM/DD/YYYY"
                        v-model="addDate"
                        :options="optionsFn"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Close"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div
              style="
                display: flex;
                flex-flow: row nowrap;
                flex: 1;
                justify-content: flex-end;
              "
            >
              <q-btn
                label="CLose"
                style="margin-right: 10px"
                outline
                @click="reset"
              ></q-btn>
              <q-btn
                label="Save"
                :loading="loading"
                :disable="loading"
                type="submit"
                color="positive"
              ></q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "../axios";
import { date } from "quasar";
import moment from "moment";
export default {
  data() {
    return {
      date: date,
      loading: false,
      class_name: [],
      class_names: [],
      type: "",
      location_id: [],
      addDate: "",
    };
  },
  mounted() {
    this.getClassNames();
  },
  computed: {
    locations() {
      return this.$store.state.reports.locations;
    },
    shorter() {
      if (this.location_id.length > 0 && this.location_id.length < 2) {
        return this.location_id[0].code;
      } else if (this.location_id.length > 1) {
        return `${this.location_id[0].code} +${this.location_id.length - 1}`;
      }
    },
    add: {
      get() {
        return this.$store.state.reports.add;
      },
      set(val) {
        this.$store.commit("reports/SET_ADD", val);
      },
    },
    types() {
      return this.$store.state.reports.types;
    },
  },
  methods: {
    locationChecker(val) {
      if (val.length === 0) return "Please choose locations";
    },
    classChecker(val) {
      if (val.length === 0) return "Please choose class names";
    },
    typeChecker(val) {
      if (!val.name) return "Please choose type of report.";
    },
    optionsFn(date) {
      const formattedToday = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "/");
      return date >= formattedToday && date <= "2050/05/22";
    },
    checkDate(val) {
      const formattedDate = moment(val, "MM/DD/YYYY");
      if (!val) return "Required field.";
      else if (new Date(val) < new Date()) {
        return "You can not choose past date";
      }
      return this.date.isValid(formattedDate) || "Invalid date.";
    },
    locationFilterPusher(location) {
      if (this.location_id.some((item) => item.id === location.id)) {
        const index = this.location_id
          .map((item) => item.id)
          .indexOf(location.id);
        if (index !== -1) {
          this.location_id.splice(index, 1);
        }
      } else {
        this.location_id = [...this.location_id, location];
      }
    },
    getClassNames() {
      axios.get("vehicle-classes").then((res) => {
        this.class_names = res.data.data;
      });
    },
    async onSubmit() {
      try {
        const body = {
          type: this.type.value,
          locations: this.location_id.map((item) => item.id),
          class_names: this.class_name.map((item) => item.name),
          from_date: new Date().toISOString().slice(0, 10),
          to_date: new Date(this.addDate).toISOString().slice(0, 10),
        };
        this.loading = true;
        const { data } = await axios.put("tsd-analyses", body);
        this.loading = false;
        this.$store.commit("reports/ADD_REPORT", data.data);
        this.reset();
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    reset() {
      this.add = false;
      this.type = "";
      this.addDate = "";
      this.location_id = [];
      this.class_name = [];
    },
  },
};
</script>
